import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { ConsentModel, DataConsentModel } from '../../../models/configuration/consent.model';

export class UpdateConsentUseCase implements UseCase<DataConsentModel, ConsentModel> {
    constructor(private ConsentRepository: ConfigurationRepository) { }
    execute(
        params: DataConsentModel,
    ): Observable<ConsentModel> {
        return this.ConsentRepository.updateConsent(params);
    }
}
